import Debug from 'debug';
import _ from 'lodash';
import clone from 'clone';
import naturalSort from 'object-property-natural-sort';
import { fieldFormatter } from '@knack/formatter';
const debug = Debug(`knack.core.helpers.reports.processConnectionGroup`);
export const processConnectionGroup = (group, old_filters, field, req) => {
    debug(`report-helper.processConnectionGroup()`);
    // get connection identifiers
    req.report.filter_groups.push([]);
    let c = 0;
    return _.each(old_filters, function (filter) {
        const conn_field = req.application.getField(group.field);
        const conn_obj = req.application.getObject(conn_field.relationship.object);
        const identifier = conn_obj.getIdentifier();
        const id_field = req.application.getField(identifier);
        // we need to sort on formatted string values. otherwise, we can end up attempting to sort on objects, which will not work.
        // this can happen in the case of name fields, where a value would be stored as { last: 'Smith', first: 'Bob' }
        _.each(group.connection_records, function (record) {
            record.values[`${identifier}_formatted`] = fieldFormatter.formatField(record, id_field, `html`, {});
        });
        group.connection_records = group.connection_records.sort(naturalSort(`values.${identifier}_formatted`));
        if (group.sort === `desc`) {
            group.connection_records = group.connection_records.reverse();
        }
        _.each(group.connection_records, function (record) {
            if (!record || !record.values) {
                return;
            }
            const header = fieldFormatter.formatField(record, id_field, `html`, {});
            const new_filter = clone(filter);
            new_filter.push({
                field: group.field,
                operator: `is`,
                value: record.id,
                header
            });
            debug(`report-helper.processConnectionGroup: pushing new filter: ${JSON.stringify(new_filter[new_filter.length - 1])}`);
            req.report.filters.push(new_filter);
            if (c === 0) {
                req.report.filter_groups[req.report.filter_groups.length - 1].push({
                    header
                });
            }
        });
        c++;
    });
};
